export default __webpack_public_path__ + "static/media/login-image.bec1064d.jpg";